/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Area_HipInputs */

const en_us2_profile_editors_pain_area_hip = /** @type {(inputs: Profile_Editors_Pain_Area_HipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hip`)
};

const pt_br2_profile_editors_pain_area_hip = /** @type {(inputs: Profile_Editors_Pain_Area_HipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quadril`)
};

const es_419_profile_editors_pain_area_hip = /** @type {(inputs: Profile_Editors_Pain_Area_HipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadera`)
};

const pt_pt2_profile_editors_pain_area_hip = /** @type {(inputs: Profile_Editors_Pain_Area_HipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anca`)
};

const fr_fr2_profile_editors_pain_area_hip = /** @type {(inputs: Profile_Editors_Pain_Area_HipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hanche`)
};

const de_de2_profile_editors_pain_area_hip = /** @type {(inputs: Profile_Editors_Pain_Area_HipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hüfte`)
};

const it_it2_profile_editors_pain_area_hip = /** @type {(inputs: Profile_Editors_Pain_Area_HipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anca`)
};

/**
* | output |
* | --- |
* | "Hip" |
*
* @param {Profile_Editors_Pain_Area_HipInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_area_hip = /** @type {((inputs?: Profile_Editors_Pain_Area_HipInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Area_HipInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_area_hip(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_area_hip(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_area_hip(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_area_hip(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_area_hip(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_area_hip(inputs)
	return en_us2_profile_editors_pain_area_hip(inputs)
});
export { profile_editors_pain_area_hip as "profile-editors.pain_area_hip" }